/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Breadcrumb } from './Breadcrumb';
import {
    BreadcrumbFromJSON,
    BreadcrumbFromJSONTyped,
    BreadcrumbToJSON,
} from './Breadcrumb';
import type { DeprecatedPagination } from './DeprecatedPagination';
import {
    DeprecatedPaginationFromJSON,
    DeprecatedPaginationFromJSONTyped,
    DeprecatedPaginationToJSON,
} from './DeprecatedPagination';
import type { Facet } from './Facet';
import {
    FacetFromJSON,
    FacetFromJSONTyped,
    FacetToJSON,
} from './Facet';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';
import type { SearchState } from './SearchState';
import {
    SearchStateFromJSON,
    SearchStateFromJSONTyped,
    SearchStateToJSON,
} from './SearchState';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';
import type { SpellingSuggestion } from './SpellingSuggestion';
import {
    SpellingSuggestionFromJSON,
    SpellingSuggestionFromJSONTyped,
    SpellingSuggestionToJSON,
} from './SpellingSuggestion';

/**
 * Representation of a Product Search Page
 * @export
 * @interface ProductSearchPage
 */
export interface ProductSearchPage {
    /**
     * Free text search
     * @type {string}
     * @memberof ProductSearchPage
     */
    freeTextSearch?: string;
    /**
     * Code of category
     * @type {string}
     * @memberof ProductSearchPage
     */
    categoryCode?: string;
    /**
     * Redirect url address keyword
     * @type {string}
     * @memberof ProductSearchPage
     */
    keywordRedirectUrl?: string;
    /**
     * 
     * @type {SpellingSuggestion}
     * @memberof ProductSearchPage
     */
    spellingSuggestion?: SpellingSuggestion;
    /**
     * List of products
     * @type {Array<Product>}
     * @memberof ProductSearchPage
     */
    products?: Array<Product>;
    /**
     * List of sorts
     * @type {Array<Sort>}
     * @memberof ProductSearchPage
     */
    sorts?: Array<Sort>;
    /**
     * 
     * @type {DeprecatedPagination}
     * @memberof ProductSearchPage
     */
    pagination?: DeprecatedPagination;
    /**
     * 
     * @type {SearchState}
     * @memberof ProductSearchPage
     */
    currentQuery?: SearchState;
    /**
     * List of breadcrumbs info
     * @type {Array<Breadcrumb>}
     * @memberof ProductSearchPage
     */
    breadcrumbs?: Array<Breadcrumb>;
    /**
     * List of facets
     * @type {Array<Facet>}
     * @memberof ProductSearchPage
     */
    facets?: Array<Facet>;
}

/**
 * Check if a given object implements the ProductSearchPage interface.
 */
export function instanceOfProductSearchPage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductSearchPageFromJSON(json: any): ProductSearchPage {
    return ProductSearchPageFromJSONTyped(json, false);
}

export function ProductSearchPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSearchPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'freeTextSearch': !exists(json, 'freeTextSearch') ? undefined : json['freeTextSearch'],
        'categoryCode': !exists(json, 'categoryCode') ? undefined : json['categoryCode'],
        'keywordRedirectUrl': !exists(json, 'keywordRedirectUrl') ? undefined : json['keywordRedirectUrl'],
        'spellingSuggestion': !exists(json, 'spellingSuggestion') ? undefined : SpellingSuggestionFromJSON(json['spellingSuggestion']),
        'products': !exists(json, 'products') ? undefined : ((json['products'] as Array<any>).map(ProductFromJSON)),
        'sorts': !exists(json, 'sorts') ? undefined : ((json['sorts'] as Array<any>).map(SortFromJSON)),
        'pagination': !exists(json, 'pagination') ? undefined : DeprecatedPaginationFromJSON(json['pagination']),
        'currentQuery': !exists(json, 'currentQuery') ? undefined : SearchStateFromJSON(json['currentQuery']),
        'breadcrumbs': !exists(json, 'breadcrumbs') ? undefined : ((json['breadcrumbs'] as Array<any>).map(BreadcrumbFromJSON)),
        'facets': !exists(json, 'facets') ? undefined : ((json['facets'] as Array<any>).map(FacetFromJSON)),
    };
}

export function ProductSearchPageToJSON(value?: ProductSearchPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'freeTextSearch': value.freeTextSearch,
        'categoryCode': value.categoryCode,
        'keywordRedirectUrl': value.keywordRedirectUrl,
        'spellingSuggestion': SpellingSuggestionToJSON(value.spellingSuggestion),
        'products': value.products === undefined ? undefined : ((value.products as Array<any>).map(ProductToJSON)),
        'sorts': value.sorts === undefined ? undefined : ((value.sorts as Array<any>).map(SortToJSON)),
        'pagination': DeprecatedPaginationToJSON(value.pagination),
        'currentQuery': SearchStateToJSON(value.currentQuery),
        'breadcrumbs': value.breadcrumbs === undefined ? undefined : ((value.breadcrumbs as Array<any>).map(BreadcrumbToJSON)),
        'facets': value.facets === undefined ? undefined : ((value.facets as Array<any>).map(FacetToJSON)),
    };
}

